[
  {
    "id": 1,
    "block": "Cognitive Style",
    "question": "When faced with a complex new problem, how do you naturally react?",
    "options": [
      {
        "label": "A) ",
        "text": "Break it down into biological or logical systems to analyze component interaction.",
        "weights": [
          3,
          1,
          1,
          0
        ]
      },
      {
        "label": "B) ",
        "text": "Construct a mathematical model or formula to solve it step-by-step.",
        "weights": [
          1,
          3,
          1,
          0
        ]
      },
      {
        "label": "C) ",
        "text": "Write a script or query an AI tool to simulate and automate the solution.",
        "weights": [
          0,
          1,
          3,
          0
        ]
      },
      {
        "label": "D) ",
        "text": "Outline core arguments and communicate the solution through clear writing.",
        "weights": [
          0,
          0,
          1,
          3
        ]
      }
    ]
  },
  {
    "id": 2,
    "block": "Cognitive Style",
    "question": "Which type of learning environment makes you feel most energized?",
    "options": [
      {
        "label": "A) ",
        "text": "Hands-on scientific research, experiments, and understanding human behavior.",
        "weights": [
          3,
          0,
          1,
          0
        ]
      },
      {
        "label": "B) ",
        "text": "Solving challenging calculus proofs and structural puzzles.",
        "weights": [
          0,
          3,
          1,
          0
        ]
      },
      {
        "label": "C) ",
        "text": "Building web apps, customizing AI agents, and immediate code feedback loops.",
        "weights": [
          0,
          1,
          3,
          0
        ]
      },
      {
        "label": "D) ",
        "text": "Engaging in deep discussions, reading, and crafting persuasive essays.",
        "weights": [
          0,
          0,
          0,
          3
        ]
      }
    ]
  },
  {
    "id": 3,
    "block": "Cognitive Style",
    "question": "How do you approach studying for a major exam?",
    "options": [
      {
        "label": "A) ",
        "text": "Active recall and active learning to master core scientific concepts.",
        "weights": [
          3,
          1,
          1,
          0
        ]
      },
      {
        "label": "B) ",
        "text": "Practicing 50+ quantitative problems until calculation is second nature.",
        "weights": [
          1,
          3,
          0,
          0
        ]
      },
      {
        "label": "C) ",
        "text": "Building digital flashcard bots or coding custom tools to test myself.",
        "weights": [
          0,
          1,
          3,
          0
        ]
      },
      {
        "label": "D) ",
        "text": "Summarizing key themes into detailed structured notes and essays.",
        "weights": [
          0,
          0,
          1,
          3
        ]
      }
    ]
  },
  {
    "id": 4,
    "block": "Cognitive Style",
    "question": "When working on a group project, what role do you naturally assume?",
    "options": [
      {
        "label": "A) ",
        "text": "The scientific strategist who ensures research accuracy and conceptual depth.",
        "weights": [
          3,
          1,
          0,
          1
        ]
      },
      {
        "label": "B) ",
        "text": "The structural lead who calculates logistics, measurements, and exact specs.",
        "weights": [
          1,
          3,
          1,
          0
        ]
      },
      {
        "label": "C) ",
        "text": "The tech lead who builds the digital presentation, website, or demo app.",
        "weights": [
          0,
          1,
          3,
          0
        ]
      },
      {
        "label": "D) ",
        "text": "The chief communicator and editor who writes and polishes the report.",
        "weights": [
          0,
          0,
          1,
          3
        ]
      }
    ]
  },
  {
    "id": 5,
    "block": "Cognitive Style",
    "question": "What kind of feedback helps you grow the fastest?",
    "options": [
      {
        "label": "A) ",
        "text": "Detailed scientific breakdowns showing where conceptual reasoning failed.",
        "weights": [
          3,
          1,
          0,
          0
        ]
      },
      {
        "label": "B) ",
        "text": "Exact numerical corrections highlighting step-by-step mathematical errors.",
        "weights": [
          1,
          3,
          0,
          0
        ]
      },
      {
        "label": "C) ",
        "text": "Code reviews and live debugging sessions showing how to optimize logic.",
        "weights": [
          0,
          1,
          3,
          0
        ]
      },
      {
        "label": "D) ",
        "text": "Line-by-line editorial feedback on tone, thesis clarity, and grammar.",
        "weights": [
          0,
          0,
          0,
          3
        ]
      }
    ]
  },
  {
    "id": 6,
    "block": "Cognitive Style",
    "question": "What do you do when you get stuck on a difficult homework problem?",
    "options": [
      {
        "label": "A) ",
        "text": "Re-examine core scientific theory to explain the underlying why.",
        "weights": [
          3,
          1,
          0,
          0
        ]
      },
      {
        "label": "B) ",
        "text": "Re-trace math calculations to find the algebraic misstep.",
        "weights": [
          0,
          3,
          0,
          0
        ]
      },
      {
        "label": "C) ",
        "text": "Inspect error logs, use prompt engineering, or debug code workflow.",
        "weights": [
          0,
          1,
          3,
          0
        ]
      },
      {
        "label": "D) ",
        "text": "Re-read the prompt and re-frame thesis statement or vocabulary.",
        "weights": [
          0,
          0,
          0,
          3
        ]
      }
    ]
  },
  {
    "id": 7,
    "block": "Cognitive Style",
    "question": "How do you handle abstract conceptual ambiguity?",
    "options": [
      {
        "label": "A) ",
        "text": "Ground abstract ideas in biological models or observable physical phenomena.",
        "weights": [
          3,
          1,
          0,
          0
        ]
      },
      {
        "label": "B) ",
        "text": "Convert abstract concepts into precise mathematical variables and equations.",
        "weights": [
          1,
          3,
          0,
          0
        ]
      },
      {
        "label": "C) ",
        "text": "Build a working digital prototype or simulation to test assumptions empirically.",
        "weights": [
          0,
          1,
          3,
          0
        ]
      },
      {
        "label": "D) ",
        "text": "Write explanatory prose to explore multiple interpretive frameworks.",
        "weights": [
          0,
          0,
          0,
          3
        ]
      }
    ]
  },
  {
    "id": 8,
    "block": "Cognitive Style",
    "question": "Which cognitive strength best describes your thinking process?",
    "options": [
      {
        "label": "A) ",
        "text": "Biological & Behavioral Synthesis (Connecting human psychology and natural science).",
        "weights": [
          3,
          0,
          0,
          1
        ]
      },
      {
        "label": "B) ",
        "text": "Mathematical Precision (Deriving order from quantitative complexity).",
        "weights": [
          0,
          3,
          0,
          0
        ]
      },
      {
        "label": "C) ",
        "text": "Computational & Algorithmic Thinking (Designing automated software systems).",
        "weights": [
          0,
          1,
          3,
          0
        ]
      },
      {
        "label": "D) ",
        "text": "Verbal Eloquence & Synthesis (Expressing nuanced ideas persuasively).",
        "weights": [
          0,
          0,
          0,
          3
        ]
      }
    ]
  },
  {
    "id": 9,
    "block": "Cognitive Style",
    "question": "What type of mental model do you use to organize complex information?",
    "options": [
      {
        "label": "A) ",
        "text": "Hierarchical taxonomy trees (like biological classification or neural networks).",
        "weights": [
          3,
          1,
          0,
          0
        ]
      },
      {
        "label": "B) ",
        "text": "Coordinate systems, vectors, and mathematical matrices.",
        "weights": [
          0,
          3,
          0,
          0
        ]
      },
      {
        "label": "C) ",
        "text": "Flowcharts, state machines, and API endpoint diagrams.",
        "weights": [
          0,
          1,
          3,
          0
        ]
      },
      {
        "label": "D) ",
        "text": "Narrative outlines, thematic clusters, and mind maps.",
        "weights": [
          0,
          0,
          0,
          3
        ]
      }
    ]
  },
  {
    "id": 10,
    "block": "Cognitive Style",
    "question": "How do you evaluate whether a solution is truly correct?",
    "options": [
      {
        "label": "A) ",
        "text": "If it aligns with proven empirical scientific research and experimental evidence.",
        "weights": [
          3,
          0,
          0,
          0
        ]
      },
      {
        "label": "B) ",
        "text": "If the mathematical proof balances with zero logical flaws.",
        "weights": [
          0,
          3,
          0,
          0
        ]
      },
      {
        "label": "C) ",
        "text": "If the code executes without bugs and passes automated test suites.",
        "weights": [
          0,
          0,
          3,
          0
        ]
      },
      {
        "label": "D) ",
        "text": "If the argument is logically sound, coherent, and withstands critique.",
        "weights": [
          0,
          0,
          0,
          3
        ]
      }
    ]
  },
  {
    "id": 11,
    "block": "Academic Track",
    "question": "Which subject do you enjoy studying the most in school?",
    "options": [
      {
        "label": "A) ",
        "text": "Biology, Chemistry, or Psychology.",
        "weights": [
          3,
          0,
          0,
          0
        ]
      },
      {
        "label": "B) ",
        "text": "Functions, Advanced Functions, Calculus, or Physics.",
        "weights": [
          0,
          3,
          0,
          0
        ]
      },
      {
        "label": "C) ",
        "text": "Computer Science, Robotics, or Data Science.",
        "weights": [
          0,
          0,
          3,
          0
        ]
      },
      {
        "label": "D) ",
        "text": "English Literature, History, or Social Sciences.",
        "weights": [
          0,
          0,
          0,
          3
        ]
      }
    ]
  },
  {
    "id": 12,
    "block": "Academic Track",
    "question": "When reading a textbook or article, what captures your attention first?",
    "options": [
      {
        "label": "A) ",
        "text": "Diagrams explaining human brain function, cellular biology, or chemistry.",
        "weights": [
          3,
          0,
          0,
          0
        ]
      },
      {
        "label": "B) ",
        "text": "Proofs, formulas, and geometric representations of real-world phenomena.",
        "weights": [
          0,
          3,
          0,
          0
        ]
      },
      {
        "label": "C) ",
        "text": "System architecture diagrams, code blocks, and AI workflow charts.",
        "weights": [
          0,
          0,
          3,
          0
        ]
      },
      {
        "label": "D) ",
        "text": "Historical quotes, literary metaphors, and rhetorical structures.",
        "weights": [
          0,
          0,
          0,
          3
        ]
      }
    ]
  },
  {
    "id": 13,
    "block": "Academic Track",
    "question": "How do you feel about Grade 11 & 12 Chemistry?",
    "options": [
      {
        "label": "A) ",
        "text": "Fascinating\u2014it explains the molecular foundation of life and medicine.",
        "weights": [
          3,
          0,
          0,
          0
        ]
      },
      {
        "label": "B) ",
        "text": "Quantitative challenge\u2014I enjoy Stoichiometry and Thermodynamics math.",
        "weights": [
          1,
          3,
          0,
          0
        ]
      },
      {
        "label": "C) ",
        "text": "Interesting when modeled digitally through molecular software simulations.",
        "weights": [
          0,
          1,
          3,
          0
        ]
      },
      {
        "label": "D) ",
        "text": "Challenging\u2014I prefer focusing on written analysis and literature.",
        "weights": [
          0,
          0,
          0,
          3
        ]
      }
    ]
  },
  {
    "id": 14,
    "block": "Academic Track",
    "question": "How do you feel about High School Mathematics (Functions / Calculus)?",
    "options": [
      {
        "label": "A) ",
        "text": "Essential quantitative tool to support high GPAs in science and pre-med.",
        "weights": [
          2,
          1,
          0,
          0
        ]
      },
      {
        "label": "B) ",
        "text": "My favorite subject\u2014I want to achieve a 95%+ grade average.",
        "weights": [
          0,
          3,
          0,
          0
        ]
      },
      {
        "label": "C) ",
        "text": "Excited when math is applied directly to machine learning and algorithms.",
        "weights": [
          0,
          1,
          3,
          0
        ]
      },
      {
        "label": "D) ",
        "text": "Prefer practical step-by-step guidance to meet admissions cut-offs.",
        "weights": [
          0,
          1,
          0,
          2
        ]
      }
    ]
  },
  {
    "id": 15,
    "block": "Academic Track",
    "question": "What is your experience with Computer Programming & AI Tools?",
    "options": [
      {
        "label": "A) ",
        "text": "Use AI tools primarily to summarize medical articles and study biology.",
        "weights": [
          2,
          0,
          1,
          0
        ]
      },
      {
        "label": "B) ",
        "text": "Use computational packages like Python/MATLAB for physics and calculus.",
        "weights": [
          0,
          2,
          2,
          0
        ]
      },
      {
        "label": "C) ",
        "text": "Actively code, vibe code, build web apps, or experiment with AI agents.",
        "weights": [
          0,
          0,
          3,
          0
        ]
      },
      {
        "label": "D) ",
        "text": "Use AI tools for proofreading essays and structural outlines.",
        "weights": [
          0,
          0,
          1,
          2
        ]
      }
    ]
  },
  {
    "id": 16,
    "block": "Academic Track",
    "question": "How do you approach essay writing and English assignments?",
    "options": [
      {
        "label": "A) ",
        "text": "Structure essays scientifically with empirical evidence and crisp analysis.",
        "weights": [
          2,
          0,
          0,
          1
        ]
      },
      {
        "label": "B) ",
        "text": "Treat essays like logical algorithms with clear structured premises.",
        "weights": [
          0,
          2,
          0,
          1
        ]
      },
      {
        "label": "C) ",
        "text": "Use AI markdown tools to organize thoughts rapidly.",
        "weights": [
          0,
          0,
          2,
          1
        ]
      },
      {
        "label": "D) ",
        "text": "Take pride in crafting deep, eloquent arguments and advanced vocabulary.",
        "weights": [
          0,
          0,
          0,
          3
        ]
      }
    ]
  },
  {
    "id": 17,
    "block": "Academic Track",
    "question": "If you had 2 hours of free time, what project would you choose?",
    "options": [
      {
        "label": "A) ",
        "text": "Reading about neuroscience breakthroughs or conducting a science experiment.",
        "weights": [
          3,
          0,
          0,
          0
        ]
      },
      {
        "label": "B) ",
        "text": "Solving a challenging math problem set or physics puzzle.",
        "weights": [
          0,
          3,
          0,
          0
        ]
      },
      {
        "label": "C) ",
        "text": "Building a mini web application or automating a task with AI.",
        "weights": [
          0,
          0,
          3,
          0
        ]
      },
      {
        "label": "D) ",
        "text": "Writing a short story, essay, or analyzing a classic film/book.",
        "weights": [
          0,
          0,
          0,
          3
        ]
      }
    ]
  },
  {
    "id": 18,
    "block": "Academic Track",
    "question": "Which university program sounds most exciting to you?",
    "options": [
      {
        "label": "A) ",
        "text": "McMaster Psychology, Neuroscience & Behaviour (or UofT Life Sciences).",
        "weights": [
          3,
          0,
          0,
          0
        ]
      },
      {
        "label": "B) ",
        "text": "Waterloo Mechanical / Electrical Engineering or UofT EngSci.",
        "weights": [
          0,
          3,
          0,
          0
        ]
      },
      {
        "label": "C) ",
        "text": "Computer Science, Software Engineering, or Artificial Intelligence.",
        "weights": [
          0,
          0,
          3,
          0
        ]
      },
      {
        "label": "D) ",
        "text": "Humanities, Pre-Law, International Relations, or Business Communications.",
        "weights": [
          0,
          0,
          0,
          3
        ]
      }
    ]
  },
  {
    "id": 19,
    "block": "Academic Track",
    "question": "What is your primary academic focus for GPA improvement?",
    "options": [
      {
        "label": "A) ",
        "text": "Mastering Grade 11/12 Chemistry & Biology concepts for Pre-Med cut-offs.",
        "weights": [
          3,
          0,
          0,
          0
        ]
      },
      {
        "label": "B) ",
        "text": "Pushing Grade 12 Advanced Functions & Calculus average to 90%+.",
        "weights": [
          0,
          3,
          0,
          0
        ]
      },
      {
        "label": "C) ",
        "text": "Building real-world software engineering and AI agent skills.",
        "weights": [
          0,
          0,
          3,
          0
        ]
      },
      {
        "label": "D) ",
        "text": "Elevating English essay writing structure and vocabulary scores.",
        "weights": [
          0,
          0,
          0,
          3
        ]
      }
    ]
  },
  {
    "id": 20,
    "block": "Academic Track",
    "question": "Which skill do you think is most vital for your long-term success?",
    "options": [
      {
        "label": "A) ",
        "text": "Deep domain expertise in natural science and human health.",
        "weights": [
          3,
          0,
          0,
          0
        ]
      },
      {
        "label": "B) ",
        "text": "Advanced quantitative and analytical reasoning.",
        "weights": [
          0,
          3,
          0,
          0
        ]
      },
      {
        "label": "C) ",
        "text": "Software development, AI agent engineering, and tech adaptability.",
        "weights": [
          0,
          0,
          3,
          0
        ]
      },
      {
        "label": "D) ",
        "text": "Written persuasion, critical analysis, and rhetoric.",
        "weights": [
          0,
          0,
          0,
          3
        ]
      }
    ]
  },
  {
    "id": 21,
    "block": "Technical Endurance",
    "question": "Where do you see yourself working in 5\u20138 years?",
    "options": [
      {
        "label": "A) ",
        "text": "Medical clinic, neuroscience lab, or healthcare organization.",
        "weights": [
          3,
          0,
          0,
          0
        ]
      },
      {
        "label": "B) ",
        "text": "Engineering firm, aerospace company, or quantitative finance.",
        "weights": [
          0,
          3,
          0,
          0
        ]
      },
      {
        "label": "C) ",
        "text": "Fast-paced tech startup, AI lab, or founding a software company.",
        "weights": [
          0,
          0,
          3,
          0
        ]
      },
      {
        "label": "D) ",
        "text": "Law firm, policy institute, publishing house, or corporate strategy.",
        "weights": [
          0,
          0,
          0,
          3
        ]
      }
    ]
  },
  {
    "id": 22,
    "block": "Technical Endurance",
    "question": "What style of academic problem set gives you the highest satisfaction?",
    "options": [
      {
        "label": "A) ",
        "text": "Deciphering complex biological pathways and chemical reaction mechanisms.",
        "weights": [
          3,
          0,
          0,
          0
        ]
      },
      {
        "label": "B) ",
        "text": "Solving a multi-page calculus optimization problem cleanly.",
        "weights": [
          0,
          3,
          0,
          0
        ]
      },
      {
        "label": "C) ",
        "text": "Building a clean script that automates a multi-step data workflow.",
        "weights": [
          0,
          0,
          3,
          0
        ]
      },
      {
        "label": "D) ",
        "text": "Writing a compelling 1,500-word argumentative essay that shifts opinions.",
        "weights": [
          0,
          0,
          0,
          3
        ]
      }
    ]
  },
  {
    "id": 23,
    "block": "Technical Endurance",
    "question": "How do you approach learning a completely unfamiliar topic?",
    "options": [
      {
        "label": "A) ",
        "text": "First principles scientific inquiry\u2014understanding foundational components.",
        "weights": [
          3,
          0,
          0,
          0
        ]
      },
      {
        "label": "B) ",
        "text": "Mathematical reduction\u2014reducing concepts to numbers and formulas.",
        "weights": [
          0,
          3,
          0,
          0
        ]
      },
      {
        "label": "C) ",
        "text": "Interactive trial-and-error\u2014building a hands-on digital sandbox.",
        "weights": [
          0,
          0,
          3,
          0
        ]
      },
      {
        "label": "D) ",
        "text": "Contextual synthesis\u2014reading literature and synthesizing perspectives.",
        "weights": [
          0,
          0,
          0,
          3
        ]
      }
    ]
  },
  {
    "id": 24,
    "block": "Technical Endurance",
    "question": "What is your preferred format for demonstrating academic mastery?",
    "options": [
      {
        "label": "A) ",
        "text": "Comprehensive laboratory reports and scientific research papers.",
        "weights": [
          3,
          0,
          0,
          0
        ]
      },
      {
        "label": "B) ",
        "text": "Timed quantitative exams with complex problem sets.",
        "weights": [
          0,
          3,
          0,
          0
        ]
      },
      {
        "label": "C) ",
        "text": "Functional digital projects, deployed apps, and live code demos.",
        "weights": [
          0,
          0,
          3,
          0
        ]
      },
      {
        "label": "D) ",
        "text": "Oral presentations, analytical essays, and written dissertations.",
        "weights": [
          0,
          0,
          0,
          3
        ]
      }
    ]
  },
  {
    "id": 25,
    "block": "Technical Endurance",
    "question": "Which university environment appeals to you most?",
    "options": [
      {
        "label": "A) ",
        "text": "McMaster University (Renowned science labs, health research focus).",
        "weights": [
          3,
          0,
          0,
          0
        ]
      },
      {
        "label": "B) ",
        "text": "University of Waterloo (Rigorous math, engineering, co-op culture).",
        "weights": [
          0,
          3,
          0,
          0
        ]
      },
      {
        "label": "C) ",
        "text": "Top Computer Science Tech Hubs (UofT, Tech Incubators, Silicon Valley).",
        "weights": [
          0,
          0,
          3,
          0
        ]
      },
      {
        "label": "D) ",
        "text": "Ivy League / Traditional Pre-Law & Humanities Universities.",
        "weights": [
          0,
          0,
          0,
          3
        ]
      }
    ]
  },
  {
    "id": 26,
    "block": "Technical Endurance",
    "question": "How do you handle difficult academic setbacks (e.g. unexpected low test score)?",
    "options": [
      {
        "label": "A) ",
        "text": "Analyze cognitive study habits and adjust active recall scientific methods.",
        "weights": [
          3,
          0,
          0,
          0
        ]
      },
      {
        "label": "B) ",
        "text": "Systematically re-do every missed math problem until 100% mastery.",
        "weights": [
          0,
          3,
          0,
          0
        ]
      },
      {
        "label": "C) ",
        "text": "Refactor my study workflow using AI tools and automated schedule tracking.",
        "weights": [
          0,
          0,
          3,
          0
        ]
      },
      {
        "label": "D) ",
        "text": "Review essay feedback line-by-line and rewrite the assignment.",
        "weights": [
          0,
          0,
          0,
          3
        ]
      }
    ]
  },
  {
    "id": 27,
    "block": "Technical Endurance",
    "question": "What level of mathematical rigor do you prefer in your daily coursework?",
    "options": [
      {
        "label": "A) ",
        "text": "Moderate math focused on chemical equations and statistical data analysis.",
        "weights": [
          2,
          1,
          0,
          0
        ]
      },
      {
        "label": "B) ",
        "text": "Extreme quantitative rigor\u2014calculus, vectors, and linear algebra.",
        "weights": [
          0,
          3,
          0,
          0
        ]
      },
      {
        "label": "C) ",
        "text": "Applied discrete math, logic gates, and algorithmic complexity.",
        "weights": [
          0,
          1,
          3,
          0
        ]
      },
      {
        "label": "D) ",
        "text": "Conceptual logic without heavy formulaic computation.",
        "weights": [
          0,
          0,
          0,
          3
        ]
      }
    ]
  },
  {
    "id": 28,
    "block": "Technical Endurance",
    "question": "How do you react to rapid changes in technology and tools?",
    "options": [
      {
        "label": "A) ",
        "text": "Fascinated by how technology accelerates biological and brain research.",
        "weights": [
          2,
          0,
          1,
          0
        ]
      },
      {
        "label": "B) ",
        "text": "Interested in the mathematical mechanics behind new tech tools.",
        "weights": [
          0,
          2,
          1,
          0
        ]
      },
      {
        "label": "C) ",
        "text": "Eager to adopt, test, and build with new AI tools and frameworks immediately.",
        "weights": [
          0,
          0,
          3,
          0
        ]
      },
      {
        "label": "D) ",
        "text": "Focused on ensuring human communication and critical thinking stay central.",
        "weights": [
          0,
          0,
          0,
          3
        ]
      }
    ]
  },
  {
    "id": 29,
    "block": "Technical Endurance",
    "question": "What type of capstone project would best showcase your talents to universities?",
    "options": [
      {
        "label": "A) ",
        "text": "An independent scientific literature review or neuroscience research paper.",
        "weights": [
          3,
          0,
          0,
          0
        ]
      },
      {
        "label": "B) ",
        "text": "An advanced physics/math modeling project with numerical simulations.",
        "weights": [
          0,
          3,
          0,
          0
        ]
      },
      {
        "label": "C) ",
        "text": "A deployed full-stack web application or autonomous AI agent.",
        "weights": [
          0,
          0,
          3,
          0
        ]
      },
      {
        "label": "D) ",
        "text": "A published policy brief, analytical essay collection, or debate portfolio.",
        "weights": [
          0,
          0,
          0,
          3
        ]
      }
    ]
  },
  {
    "id": 30,
    "block": "Technical Endurance",
    "question": "What environmental setting helps you sustain deep focus for 3+ hours?",
    "options": [
      {
        "label": "A) ",
        "text": "Quiet science library or research laboratory setting.",
        "weights": [
          3,
          0,
          0,
          0
        ]
      },
      {
        "label": "B) ",
        "text": "Clean workspace with dual monitors, graph paper, and scientific calculator.",
        "weights": [
          0,
          3,
          0,
          0
        ]
      },
      {
        "label": "C) ",
        "text": "Modern tech workspace with code editor, terminal, and AI tools open.",
        "weights": [
          0,
          0,
          3,
          0
        ]
      },
      {
        "label": "D) ",
        "text": "Comfortable reading room surrounded by literature and notes.",
        "weights": [
          0,
          0,
          0,
          3
        ]
      }
    ]
  }
]